import { SVGProps } from "react";

export const GooglePlayBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlSpace="preserve"
    viewBox="0 0 862 334"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="a">
        <path d="M0 2207.04h6460V292.961H0Z" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" transform="matrix(.13333 0 0 -.13333 0 333.333)">
      <path
        d="M6220.74 292.969H239.262C107.668 292.969 0 400.629 0 532.23v1435.55c0 131.6 107.668 239.26 239.262 239.26H6220.74c131.59 0 239.26-107.66 239.26-239.26V532.23c0-131.601-107.67-239.261-239.26-239.261"
        style={{
          fill: "#100f0d",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
      <path
        d="M6220.74 2207.04H239.262C107.668 2207.04 0 2099.36 0 1967.77V532.219c0-131.598 107.668-239.258 239.262-239.258H6220.74c131.59 0 239.26 107.66 239.26 239.258V1967.77c0 131.59-107.67 239.27-239.26 239.27m0-38.29c110.83 0 200.98-90.15 200.98-200.98V532.219c0-110.828-90.15-200.981-200.98-200.981H239.262c-110.828 0-200.977 90.153-200.977 200.981V1967.77c0 110.83 90.149 200.98 200.977 200.98H6220.74"
        style={{
          fill: "#a2a2a1",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
      <path
        d="M5117.09 1297.85h89.29v598.2h-89.29zm804.24 382.72-102.35-259.36h-3.07l-106.23 259.36h-96.18l159.3-362.48-90.82-201.65h93.12l245.53 564.13zm-506.36-314.77c-29.29 0-70.06 14.64-70.06 50.82 0 46.17 50.77 63.83 94.65 63.83 39.24 0 57.71-8.47 81.59-20-6.94-55.41-54.65-94.65-106.18-94.65m10.76 327.83c-64.65 0-131.64-28.47-159.34-91.54l79.28-33.11c16.94 33.11 48.48 43.88 81.59 43.88 46.18 0 93.12-27.71 93.89-76.95v-6.17c-16.17 9.23-50.82 23.06-93.12 23.06-85.42 0-172.41-46.94-172.41-134.65 0-80.06 70.05-131.59 148.53-131.59 60.05 0 93.12 26.89 113.94 58.47h3.06v-46.18h86.18v229.36c0 106.18-79.24 165.42-181.6 165.42m-551.83-85.89h-127v205.09h127c66.76 0 104.65-55.32 104.65-102.55 0-46.37-37.89-102.54-104.65-102.54m-2.29 288.31h-213.95v-598.2h89.24v226.63h124.71c98.96 0 196.24 71.68 196.24 185.8 0 114.13-97.28 185.77-196.24 185.77M3704.93 1365.7c-61.68 0-113.31 51.63-113.31 122.55 0 71.73 51.63 124.13 113.31 124.13 60.91 0 108.67-52.4 108.67-124.13 0-70.92-47.76-122.55-108.67-122.55m102.5 281.37h-3.06c-20.05 23.88-58.57 45.51-107.14 45.51-101.79 0-195.05-89.44-195.05-204.33 0-114.08 93.26-202.75 195.05-202.75 48.57 0 87.09 21.58 107.14 46.27h3.06v-29.28c0-77.9-41.59-119.49-108.67-119.49-54.75 0-88.67 39.29-102.55 72.45l-77.86-32.39c22.35-53.98 81.74-120.26 180.41-120.26 104.84 0 193.51 61.68 193.51 211.99v365.44h-84.84zm146.47-349.22h89.44v598.24h-89.44zm221.27 197.34c-2.29 78.67 60.91 118.72 106.37 118.72 35.51 0 65.56-17.71 75.56-43.16zm277.54 67.85c-16.99 45.51-68.62 129.54-174.23 129.54-104.84 0-191.93-82.5-191.93-203.56 0-114.08 86.33-203.52 201.94-203.52 93.31 0 147.23 57.04 169.63 90.2l-69.38 46.28c-23.17-33.93-54.75-56.28-100.25-56.28-45.47 0-77.86 20.82-98.68 61.63l272.14 112.6zm-2168.07 67.04v-86.32h206.58c-6.18-48.57-22.35-84.03-46.99-108.67-30.1-30.1-77.14-63.22-159.59-63.22-127.24 0-226.67 102.5-226.67 229.74 0 127.19 99.43 229.69 226.67 229.69 68.62 0 118.72-26.94 155.71-61.63l60.91 60.87c-51.67 49.33-120.25 87.13-216.62 87.13-174.23 0-320.7-141.88-320.7-316.06 0-174.28 146.47-316.11 320.7-316.11 94.03 0 164.95 30.87 220.45 88.67 57.04 57.04 74.8 137.19 74.8 201.99 0 20.04-1.54 38.52-4.65 53.92zm530.1-264.38c-61.63 0-114.84 50.87-114.84 123.32 0 73.26 53.21 123.36 114.84 123.36 61.68 0 114.89-50.1 114.89-123.36 0-72.45-53.21-123.32-114.89-123.32m0 326.88c-112.55 0-204.28-85.61-204.28-203.56 0-117.15 91.73-203.52 204.28-203.52s204.33 86.37 204.33 203.52c0 117.95-91.78 203.56-204.33 203.56m445.69-326.88c-61.67 0-114.89 50.87-114.89 123.32 0 73.26 53.22 123.36 114.89 123.36 61.69 0 114.85-50.1 114.85-123.36 0-72.45-53.16-123.32-114.85-123.32m0 326.88c-112.54 0-204.28-85.61-204.28-203.56 0-117.15 91.74-203.52 204.28-203.52 112.55 0 204.28 86.37 204.28 203.52 0 117.95-91.73 203.56-204.28 203.56"
        style={{
          fill: "#fff",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
      <path
        d="M991.355 1277.56 481.879 736.828c.047-.09.047-.238.098-.328 15.644-58.719 69.238-101.93 132.882-101.93 25.457 0 49.336 6.891 69.817 18.95l1.625.96 573.459 330.899-268.405 292.181"
        style={{
          fill: "#eb3131",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
      <path
        d="m1506.77 1369.64-.48.33-247.59 143.51-278.927-248.21L1259.7 985.43l246.25 142.07c43.16 23.36 72.5 68.86 72.5 121.31 0 52.16-28.91 97.43-71.68 120.83"
        style={{
          fill: "#f6b60b",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
      <path
        d="M481.871 1763.11c-3.066-11.29-4.691-23.16-4.691-35.41V772.191c0-12.242 1.625-24.113 4.738-35.363l526.942 526.902-526.989 499.38"
        style={{
          fill: "#5778c5",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
      <path
        d="m995.121 1249.95 263.659 263.62-572.784 332.09c-20.816 12.49-45.125 19.67-71.109 19.67-63.641 0-117.332-43.31-132.981-102.07 0-.05-.047-.1-.047-.15l513.262-513.16"
        style={{
          fill: "#3bad49",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
      <text
        transform="matrix(10 0 0 -10 1965.73 621.559)"
        style={{
          fontVariant: "normal",
          fontSize: "41.6311px",
          fontFamily: "KozGoPr6N-Regular-90pv-RKSJ",
          fill: "#fff",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      >
        <tspan
          x="0 40.757027 82.014053 123.64516 164.27718 205.82405 243.75023"
          y={0}
        >
          {"\u3067\u624B\u306B\u5165\u308C\u3088\u3046"}
        </tspan>
      </text>
    </g>
  </svg>
);
